import React from "react";
import { Link } from "react-router-dom";
import "../styles/BlogFile.css";

function Blog6() {
  return (
    <div className="blog-post-container">
      <h2 className="blog-post-title">The Role of AI in Preventing Chronic Traumatic Encephalopathy</h2>
      <p className="blog-post-date">August 2025</p>

      <h3 className="blog-post-title">The Growing Concern Around CTE</h3>
      <p className="blog-post-content">
        Chronic Traumatic Encephalopathy (CTE) is a degenerative brain disease caused by repeated head trauma. Detecting and preventing CTE has been 
        one of the most significant challenges in sports and military medicine. AI-powered diagnostic tools are now being used to identify early warning signs 
        and implement preventative strategies.
      </p>

      <h3 className="blog-post-title">How AI Can Help Detect Early CTE Risk</h3>
      <p className="blog-post-content">
        AI-driven imaging analysis and biomarker detection are advancing research into how CTE develops over time. The integration of AI with medical scans is allowing 
        researchers to identify neurological damage in its earliest stages.
      </p>

      <div className="back-to-blog">
        <Link to="/blog">← Back to Blog</Link>
      </div>
    </div>
  );
}

export default Blog6;